import {  createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { MixState, MixInterface } from "../../entities/Mix";
import { fetchMixesByWebshop } from "./actions";

const initialState: MixState = {
  isLoading: false,
  error: undefined,
  data: {
    mixes: [],
  },
};

const mixSlice = createSlice({
  name: "mixSlice",
  initialState,
  reducers: {
    setMixes(state: MixState, action: PayloadAction<MixInterface[]>) {
      state.data.mixes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMixesByWebshop.pending, (state: MixState) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(fetchMixesByWebshop.fulfilled, (
        state: MixState,
        action: PayloadAction<MixInterface[]>,
      ) => {
        state.isLoading = false;
        state.error = undefined;
        state.data.mixes = action.payload;
      })
      .addCase(fetchMixesByWebshop.rejected, (
        state: MixState,
        action
      ) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { setMixes } = mixSlice.actions;

export default mixSlice.reducer;
